import React, { Component } from 'react';
import { translate } from 'react-translate';
import { Icon, Label } from 'semantic-ui-react';
import './TechnicalInfoIcon.css';


export class TechnicalInfoIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelDisplay: false,
    };
  }

  hide = () => {
    const self = this;
    setTimeout(() => {
      self.setState({ labelDisplay: false });
    }, 1000);
  }

  render() {
    const { t } = this.props;
    return (
      <div className="infoBulle">
        <Icon name="exclamation circle" onMouseEnter={() => this.setState({ labelDisplay: true })} />
        {this.state.labelDisplay && (
        <Label as="a" pointing="below" color="blue" className="labelMasked" onClick={this.props.onClick} onMouseLeave={this.hide}>
          {t('file_download')}
        </Label>
        )
        }
      </div>
    );
  }
}

export default translate('TechnicalInfoIcon')(TechnicalInfoIcon);



// WEBPACK FOOTER //
// ./src/components/shared/TechnicalInfoIcon.jsx